<template>
  <div>
    <b-card title="عرض المركز">
      <b-row v-if="center">
        <b-col
          cols="12"
          md="6"
        >
          <dl class="row">
            <dt class="col-sm-4">
              الاسم العربي:
            </dt>
            <dd class="col-sm-8">
              {{ center.name_ar }}
            </dd>

            <dt class="col-sm-4">
              الاسم الانجليزي:
            </dt>
            <dd class="col-sm-8">
              {{ center.name_en }}
            </dd>

            <dt class="col-sm-4">
              المحافظة:
            </dt>
            <dd class="col-sm-8">
              {{ center.governorate ? center.governorate.name_ar : '-' }}
            </dd>
          </dl>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <dl class="row">
            <dt class="col-sm-4">
              الحالة:
            </dt>
            <dd class="col-sm-8">
              <b-badge :variant="center.is_active ? 'success' : 'danger'">
                {{ center.is_active ? $t('common.active') : $t('common.inactive') }}
              </b-badge>
            </dd>

            <dt class="col-sm-4">
              عدد المدن:
            </dt>
            <dd class="col-sm-8">
              {{ center.districts_count || 0 }}
            </dd>
          </dl>
        </b-col>

        <b-col
          cols="12"
          class="mt-2"
        >
          <b-button
            variant="primary"
            :to="{ name: 'settings-centers-edit', params: { id: $route.params.id } }"
          >
            تعديل
          </b-button>
          <b-button
            variant="outline-secondary"
            class="ml-1"
            @click="$router.go(-1)"
          >
            العودة
          </b-button>
        </b-col>
      </b-row>

      <div
        v-else
        class="text-center py-4"
      >
        <b-spinner variant="primary" />
        <p class="mt-2">
          جاري التحميل...
        </p>
      </div>

      <!-- Activity Logs Section -->
      <b-row
        v-if="hasPermission('view activity_logs') && center"
        class="mt-3"
      >
        <b-col cols="12">
          <b-card header="سجل النشاطات">
            <ActivityLogs
              :model-type="'center'"
              :model-id="Number($route.params.id)"
              :show-filters="true"
              :per-page="15"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BBadge, BButton, BSpinner,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ActivityLogs from '@/components/ActivityLogs.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
    BButton,
    BSpinner,
    ActivityLogs,
  },
  computed: {
    ...mapGetters({
      center: 'centers/center',
    }),
  },
  mounted() {
    this.fetchCenter()
  },
  methods: {
    hasPermission(permission) {
      const userPermissions = this.$store.getters['users/user_permissions']
      if (Array.isArray(userPermissions)) {
        return userPermissions.includes(permission)
      }
      return Object.values(userPermissions || {}).includes(permission)
    },
    fetchCenter() {
      this.$store.dispatch('centers/get', this.$route.params.id)
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطأ',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: (error.response && error.response.data && error.response.data.message) || error.message,
            },
          })
          this.$router.push({ name: 'settings-centers' })
        })
    },
  },
}
</script>
